import $ from 'jquery';
import screenSize from './../../../common/screen_size_util';

/* this module affects the category list styling and movement on the annual homepage */

module.exports = function () {
    var viewport = screenSize.getSize();

    var evenOdd= $('.mic-list-companies__past-years').length;

    function isEven(n) {
       return n % 2 == 0;
    }

    if (viewport === 'xxlarge' || viewport === 'xlarge') {
        $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', 0);
    }

    if (viewport === 'large' || viewport === 'medium') {
        $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', 0);
        $('.mic-list-companies__past-years').slice(-2).addClass('mic-list-companies__no-border');

    }

    if (viewport === 'small') {
        if(container.length === 9){
           $(container).slice(-1).css('display', 'none');
           $(container).slice(-2).addClass('mic-list-companies__no-border');
           $(container).slice(-2).css('padding-bottom', '18px');
        }

        $('.mic-list-companies__past-years').slice(0, 2).css('padding-top', '12px');
        $('.mic-list-companies__past-years').slice(-2).removeClass('mic-list-companies__no-border');

    }

};
